import React, { Component } from "react";
import { Trans, withTranslation } from 'react-i18next';
import Footer from "../../components/Footer.jsx";
import RimiLogoHeaderButton from "../../components/HeaderComponents/RimiLogoHeaderButton.jsx";
import AutoHideableHeader from "../../components/HeaderComponents/AutoHideableHeader.jsx";
import StepBackHeader from "../../components/HeaderComponents/StepBackHeader.jsx";
import SmartIdService from "../../services/SmartidService.js";
import { SmartIdContext } from "../../tools/context/SmartIdContext.jsx";
import { MethodSelector } from "../../SmartId/Shared/MethodSelector.jsx";
import SmartIdRegistrationPersonalCodeStep from "./SmartIdRegistrationPersonalCodeStep.jsx";
import EmailVerificationRegistration from "./EmailVerificationRegistration.jsx";
import { RegistrationFooter } from "./RegistrationFooter.jsx";
import * as constants from "../../constants/constants.jsx";

class CreateNewMyRimiAccount extends Component {
	state = {
		isSmartIdSelected: false,
		isSmartIdVerifying: false,
		isSmartIdEnabled: false
	};

	componentDidMount() {
		this.setState({ isSmartIdEnabled: SmartIdService.isSmartIdEnabled(this.props.initialData?.smartIdConfig) });
		window.addEventListener(constants.COUNTRY_CHANGED, this.handleCountryChange);
	}

	componentWillUnmount() {
		window.removeEventListener(constants.COUNTRY_CHANGED, this.handleCountryChange);
	}

	handleCountryChange = () => {
		this.setState({
			isSmartIdEnabled: SmartIdService.isSmartIdEnabled(this.props.initialData?.smartIdConfig)
		});
	}

	onMethodChange = (isSmartId) => {
		this.setState({
			isSmartIdSelected: isSmartId
		});
	};

	render() {
		const shouldShowMethodSelector = !this.state.isSmartIdVerifying;
		const { isSmartIdEnabled } = this.state;

		return (
			<React.Fragment>
				<SmartIdContext.Provider value={isSmartIdEnabled} />
				<div className="container">
					<div className="card">
						<AutoHideableHeader>
							<RimiLogoHeaderButton initialData={this.props.initialData} />
							<StepBackHeader
								pathName={'/login'}
								buttonText={'step_back_button_label'} />
						</AutoHideableHeader>
						<div className="card-content no-padding-bottom">
							{shouldShowMethodSelector && (
								<>
									<h1>
										<Trans i18nKey='create_new_my_rimi_account'>
											Create new <b>My Rimi account</b>
										</Trans>
									</h1>
									<MethodSelector
										isSmartIdEnabled={isSmartIdEnabled}
										isSmartIdMethodSelected={this.state.isSmartIdSelected}
										onMethodChange={this.onMethodChange}
										textKey="create_new_my_rimi_account_page_choose_method"
									/>
								</>
							)}
							{this.state.isSmartIdSelected ? (
								<SmartIdRegistrationPersonalCodeStep 
									initialData={this.props.initialData}
									location={this.props.location}
									onVerificationStateChange={(isVerifying) => {
										this.setState({ isSmartIdVerifying: isVerifying });
									}}
								/>
							) : (
								<EmailVerificationRegistration 
									initialData={this.props.initialData}
									location={this.props.location}
								/>
							)}
						</div>
						<RegistrationFooter />
					</div>
				</div>
				<Footer countrySelectionEnabled={false} />
			</React.Fragment>
		);
	}
}

export default withTranslation()(CreateNewMyRimiAccount); 